module.exports = __webpack_public_path__ + "img/4.14b60ec9.jpg";